import { render, staticRenderFns } from "./subPage.vue?vue&type=template&id=6e3f45bc&scoped=true&"
import script from "./subPage.vue?vue&type=script&lang=js&"
export * from "./subPage.vue?vue&type=script&lang=js&"
import style0 from "./subPage.vue?vue&type=style&index=0&id=6e3f45bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3f45bc",
  null
  
)

export default component.exports